<p class="file" *ngIf="!download">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</p>
<a class="file" *ngIf="download" (click)="downloadFile(file)">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <p class="file-name">
    {{ file.name }}
  </p>
  <p class="file-size" *ngIf="file.size">{{ file.size | convertSize }}</p>
</ng-template>
